import { CommonModule } from '@angular/common';
import { Component, OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatFormFieldModule} from '@angular/material/form-field';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'app-pagination',
  standalone: true,
  imports: [CommonModule, FormsModule, MatFormFieldModule, MatSelectModule, MatInputModule],
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss', '../../../app.component.scss']
})
export class PaginationComponent implements OnInit, OnChanges {

  @Input() totalPages: number = 0;
  @Output() queryPage = new EventEmitter<Number>();

  public currentPage: number = 1;
  public maxPage: number = 5;

  public pages: Array<Number> = [];

  ngOnInit(){    
    this.onPageChange();
  }
  
  ngOnChanges(changes: SimpleChanges){
    if (!changes.totalPages.firstChange) {
      this.totalPages = changes.totalPages.currentValue;
      this.onPageChange();
    }
  }

  pageStart(){
    this.currentPage = 1;
    this.queryPage.emit(this.currentPage);
    this.onPageChange();
  }

  pagePrevious(){
    if (this.currentPage > 1) {
      this.currentPage --;
      this.queryPage.emit(this.currentPage);
      this.onPageChange();
    }
  }
  pageNext(){
    if (this.totalPages > this.currentPage) {
      this.currentPage ++;
      this.queryPage.emit(this.currentPage);
      this.onPageChange();
    }
  }

  pageEnd(){
    this.currentPage = this.totalPages;
    this.queryPage.emit(this.currentPage);
    this.onPageChange();
  }

  onPageClick(page: number){
    if (page !== this.currentPage) {
      this.currentPage = page;
      this.queryPage.emit(this.currentPage);
      this.onPageChange();
    }
  }

  onCurrentPageChange(page: number){
    this.currentPage = page;
  }

  onPageChange(){
    this.pages = this.pageNumbers(this.totalPages, this.maxPage, this.currentPage);
  }

  pageNumbers(total: number, max: number, current: number) {
    const half = Math.floor(max / 2);
    let to = max;
    
    if(current + half >= total) {
      to = total;
    } else if(current > half) {
      to = current + half ;
    }
    
    let from = Math.max(to - max, 0);
  
    return Array.from({length: Math.min(total, max)}, (_, i) => (i + 1) + from);
  }
}
